import { Box, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'

type GridItemProps = {
  children: React.ReactNode
  heading: string
  icon: string
  alignCenter?: boolean
}

const GridItem = ({ children, heading, icon, alignCenter }: GridItemProps) => (
  <Box textAlign={alignCenter ? 'center' : 'left'}>
    <CloudflareImage src={`/images/icon/${icon}.svg`} width="72" height="72" />
    <Typography variant="h5" component="h2">
      {heading}
    </Typography>
    <Typography variant="p2">{children}</Typography>
  </Box>
)

export default GridItem
